import "./../css/style.css"
import {ILazyLoadInstance} from "vanilla-lazyload"
import {lazyLoading} from "./lazyload/lazyload-init"

declare global {
  interface Window {
    lazyloading?: ILazyLoadInstance
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dataLayer: Record<string, any>[]
  }
}
window.lazyloading = lazyLoading // add lazyloading to global window object

async function loadFancybox() {
  if (document.querySelectorAll("[data-fancybox]").length) {
    await import("./fancybox/fancybox")
  }
}
async function loadMain() {
  await import("./main")
  loadFancybox()
}
loadMain()

async function loadFormValidation() {
  if (document.querySelectorAll('[data-validate="jquery"]').length) {
    await import("./form-validation")
  }
}
loadFormValidation()

async function loadFileInput() {
  if (document.querySelectorAll(".f-file").length) {
    await import("../components/fields/file-field/file-field")
  }
}
loadFileInput()

async function loadCalendar() {
  if (document.querySelectorAll(".s-calendar").length) {
    await import("../components/sections/calendar-section/calendar-section")
  }
}
loadCalendar()

async function loadSlimSelect() {
  if (document.querySelectorAll(".slim-select").length) {
    await import("./slim-select/slim-select")
  }
}
loadSlimSelect()

async function loadAlerts() {
  if (document.querySelectorAll(".i-alert").length) {
    await import("../components/items/alert-item/alert-item")
  }
}
loadAlerts()

async function loadSwiper() {
  if (document.querySelectorAll(".swiper").length) {
    await import("./swiper/swiper")
  }
}
loadSwiper()

async function loadCheckboxSelectField() {
  if (document.querySelectorAll(".f-checkbox-select").length) {
    await import("./../components/fields/checkbox-select-field")
  }
}
loadCheckboxSelectField()

async function loadDateInput() {
  if (document.querySelectorAll(".f-date").length) {
    await import("../components/fields/date-field/date-field")
  }
}
loadDateInput()

async function loadFilterItem() {
  if (document.querySelectorAll(".i-filter").length) {
    await import("../components/items/filter-item/filter-item")
  }
}
loadFilterItem()

async function loadEventWFilterSection() {
  if (document.querySelectorAll(".i-filter").length) {
    await import("../components/sections/events-w-filter-section/events-w-filter-section")
  }
}
loadEventWFilterSection()

async function loadShareButtons() {
  if (document.querySelectorAll(".share-buttons__copy-link").length) {
    await import("../components/share-buttons/share-buttons")
  }
}
loadShareButtons()

async function loadFiltrationItem() {
  if (document.querySelectorAll(".i-filtration").length) {
    await import("../components/items/filtration-item/filtration-item")
  }
}
loadFiltrationItem()

async function loadRangeSliderField() {
  if (document.querySelectorAll(".f-range-slider").length) {
    await import("../components/fields/range-slider-field/range-slider-field")
  }
}
loadRangeSliderField()

async function loadCheckboxField() {
  if (document.querySelectorAll(".f-checkbox").length) {
    await import("../components/fields/checkbox-field/checkbox-field")
  }
}
loadCheckboxField()

async function loadMultitagsSelectField() {
  if (document.querySelectorAll(".f-multitags-select").length) {
    await import("../components/fields/multitags-select-field/multitags-select-field")
  }
}
loadMultitagsSelectField()

async function loadDateRangeSelectField() {
  if (document.querySelectorAll(".f-date-range-select").length) {
    await import("../components/fields/date-range-select-field/date-range-select-field")
  }
}
loadDateRangeSelectField()

async function loadProductSction() {
  if (document.querySelectorAll(".s-product").length) {
    await import("../components/sections/product-section/product-section")
  }
}
loadProductSction()

async function loadFilterAsideForm() {
  if (document.querySelectorAll(".f-filter-aside").length) {
    await import("../components/forms/filter-aside-form/filter-aside-form")
  }
}
loadFilterAsideForm()

async function loadBtnCopyToClipboard() {
  if (document.querySelectorAll(".btn-copy-to-clipboard").length) {
    await import("@components/button/button-copy-to-clipboard")
  }
}
loadBtnCopyToClipboard()

async function loadProductDetailGallery() {
  if (document.querySelectorAll(".s-product-detail__gallery").length) {
    await import("@components/sections/product-detail-section/product-detail-section__gallery/product-detail-section__gallery")
  }
}
loadProductDetailGallery()
